/**
 * @generated SignedSource<<850e5903cb409efe67dc3f175f32713e>>
 * @relayHash 0037f0127930d19b89ff8452b4675956
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-misc/562.0.0-2026-06-02T14:54:53.634Z/GetHelpZendeskArticlesSearchRefetchQuery

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type GetHelpZendeskArticlesSearchRefetchQuery$variables = {
  isCheckout?: boolean | null;
  isSeller?: boolean | null;
  query?: string | null;
  sellerId?: string | null;
};
export type GetHelpZendeskArticlesSearchRefetchQuery$data = {
  readonly viewer: {
    readonly " $fragmentSpreads": FragmentRefs<"GetHelpZendeskArticlesSearch_viewer">;
  };
};
export type GetHelpZendeskArticlesSearchRefetchQuery = {
  response: GetHelpZendeskArticlesSearchRefetchQuery$data;
  variables: GetHelpZendeskArticlesSearchRefetchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "isCheckout"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "isSeller"
  },
  {
    "defaultValue": "",
    "kind": "LocalArgument",
    "name": "query"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "sellerId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "query",
    "variableName": "query"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "serviceId",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "title",
    "storageKey": null
  },
  (v2/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "GetHelpZendeskArticlesSearchRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "kind": "FragmentSpread",
            "name": "GetHelpZendeskArticlesSearch_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "GetHelpZendeskArticlesSearchRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "isSeller",
                "variableName": "isSeller"
              },
              {
                "kind": "Variable",
                "name": "sellerId",
                "variableName": "sellerId"
              }
            ],
            "concreteType": "Contact1stdibsZendeskArticles",
            "kind": "LinkedField",
            "name": "zendeskArticles",
            "plural": false,
            "selections": [
              {
                "alias": "articlesSearch",
                "args": (v1/*: any*/),
                "concreteType": "ZendeskArticle",
                "kind": "LinkedField",
                "name": "articles",
                "plural": true,
                "selections": (v3/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "isCheckout",
                    "variableName": "isCheckout"
                  }
                ],
                "concreteType": "ZendeskArticle",
                "kind": "LinkedField",
                "name": "promotedArticles",
                "plural": true,
                "selections": (v3/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-misc/562.0.0-2026-06-02T14:54:53.634Z/GetHelpZendeskArticlesSearchRefetchQuery",
    "metadata": {},
    "name": "GetHelpZendeskArticlesSearchRefetchQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "8e23b260175910a31069b2c4566b84b1";

export default node;
